/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Calm_Heron_WadeInputs */

const en_bold_calm_heron_wade = /** @type {(inputs: Bold_Calm_Heron_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Round IDs`)
};

const de_bold_calm_heron_wade = /** @type {(inputs: Bold_Calm_Heron_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell-Runden-IDs`)
};

/**
* | output |
* | --- |
* | "Source Round IDs" |
*
* @param {Bold_Calm_Heron_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_calm_heron_wade = /** @type {((inputs?: Bold_Calm_Heron_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Calm_Heron_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_calm_heron_wade(inputs)
	return de_bold_calm_heron_wade(inputs)
});